import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/29/thumb-landscape.jpg"

const Post29 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">BALENCIAGA／ショッピングフォンホルダー／12 x17 x4cm</span>  
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>BALENCIAGA（バレンシアガ）はスペイン発のラグジュアリーブランド。独創的なデザインが魅力で、多くのファッショニスタ達に支持されています。<br></br>2015年にデムナ・ヴァザリアがアーティスティック・ディレクターに就任して以来、ラグジュアリーストリート路線を確立。若い世代からも愛されるブランドとなりました。<br></br>様々な芸能人やモデルたちがこぞって愛用しているバレンシアガのバッグから、おすすめ10選をご紹介します。</p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>ヴィルトップハンドル</h2>
          <p>ブランドロゴがドンッと入ったカーフスキンのバッグ。上品な定番のフォルムなのに、ロゴが入ることでモードに変身。大人仕様のロゴバッグなのです。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
          <StaticImage src="../../images/posts/29/1.jpg" alt="" />
        </figure>          
        <figure className="img-small">
          <StaticImage src="../../images/posts/29/2.jpg" alt="" />
          <span className="text-center">36x28x16cm</span>
        </figure>
        </div>
        <div className="text-max-width">
          <h2>カバ</h2>
          <p>数多くの芸能人やモデルから愛用されているキャンバストート「カバ」。シンプルなデザインがどんなスタイルにもマッチする、持っているだけでこなれた印象を演出してくれるバッグです。</p>          
        </div>
        <figure className="img-small">
        <StaticImage src="../../images/posts/29/3.jpg" alt="" />
        </figure>          
        <figure className="img-small">
            <StaticImage src="../../images/posts/29/4.jpg" alt="" />
            <span className="text-center">30x23x17cm</span>
        </figure>
        <div className="text-max-width">
          <h2>カメラバッグ</h2>
          <p>各ブランドから発表されているカメラバッグ。バレンシアガにもあります！四角いシンプルなフォルムで、使いやすいのが人気の理由。マチがあるので見た目以上の収納力です！</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/29/5.jpg" alt="" />
        </figure>        
        <figure className="img-small">
          <StaticImage src="../../images/posts/29/6.jpg" alt="" />
          <span className="text-center">22x16x5cm</span>
        </figure>     
        <div className="text-max-width">
          <h2>シティ</h2>
          <p>バレンシアガの名を一気に広めたブランドを代表するアイコンバッグ「シティ」。バッグの中央に入ったジッパーと下サイドのベルト、レザータッセルが付いたクールなデザインは、コーデをカッコ良く決めてくれること間違いなしです♪</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/29/7.jpg" alt="" />
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/29/8.jpg" alt="" />
              <span className="text-center">38x23x14cm</span>
          </figure>
        </div>    
        <div className="text-max-width">
          <h2>エブリデイトート</h2>
          <p>その名の通り毎日使えることを最優先に作られた優秀バッグ。肩掛けできる細めのハンドルはどこか女性らしく、上質なカーフスキンからは高級感が漂います。</p>
        </div>
        <figure>
            <StaticImage src="../../images/posts/29/9.jpg" alt="" />
        </figure>
        <figure className="img-small">
            <StaticImage src="../../images/posts/29/10.jpg" alt="" />
            <span className="text-center">24x27x11cm</span>
        </figure>       
        <Link to="https://laxus.co/app/pc/bags/balenciaga" className="view-all-button">
          バレンシアガのバッグを見る
        </Link>        
        <div className="text-max-width">
          <h2>エクスプローラーベルトバッグ</h2>
          <p>大きめのロンTに合わせれば、ラグジュアリーなストリートファッションの完成。ユニセックスなデザインなので、メンズライクに楽しみたい♪</p>
        </div>
        <figure>
            <StaticImage src="../../images/posts/29/11.jpg" alt="" />
        </figure>        
        <figure className="img-small">
            <StaticImage src="../../images/posts/29/12.jpg" alt="" />
            <span className="text-center">20x18x6cm</span>
        </figure>      
        <div className="text-max-width">
          <h2>ショッピング　トートバッグ</h2>
          <p>お買い物の時に商品を入れてもらえるペーパーバッグをモチーフににした「ショッピングトートバッグ」。発売当初から大人気のシリーズです。ストラップがついているのでクロスボディでもOK！</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/29/13.jpg" alt="" />
          </figure>        
          <figure className="img-small">
              <StaticImage src="../../images/posts/29/14.jpg" alt="" />
              <span className="text-center">19x20x9cm</span>
          </figure>
        </div>        
        <div className="text-max-width">
          <h2>トライアングルダッフル</h2>
          <p>バレンシアガらしいエッジのきいたデザインながら、ハンドでもショルダーでもOK。デイリーで使いやすいバッグです。そして、グレーはどんなお洋服にも馴染みやすい万能カラー。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/29/15.jpg" alt="" />
        </figure>            
        <figure className="img-small">
          <StaticImage src="../../images/posts/29/16.jpg" alt="" />
          <span className="text-center">23x23x9cm</span>
        </figure>      
        <div className="text-max-width">
          <h2>バザール</h2>
          <p>ショルダーとしても使える2wayタイプのトートバッグ「バザール」。シンプルなデザインはどんな服装にも合わせやすく、オンでもオフでも活躍してくれること間違いなしです♪オフィスカジュアルで持つなら、ブラックやネイビーをどうぞ。</p>
        </div>
        <figure>
          <StaticImage src="../../images/posts/29/17.jpg" alt="" />
        </figure>
        <figure className="img-small">
            <StaticImage src="../../images/posts/29/18.jpg" alt="" />
          <span className="text-center">37x38x16cm</span>
        </figure>
        <div className="text-max-width">
          <h2>ホイールバッグパック</h2>
          <p>トップに大きなロゴをあしらったシンプルなフォルムのリュックです。軽くて容量もたっぷりなので、マザーズバッグにするおしゃれママも！</p>
        </div>
        <figure>
          <StaticImage src="../../images/posts/29/19.jpg" alt="" />
        </figure>            
        <figure className="img-small">
          <StaticImage src="../../images/posts/29/20.jpg" alt="" />
          <span className="text-center">22x34x12cm</span>
        </figure>
        <div className="text-two-cloumn">
          <h2>オシャレ上級者に変身！</h2>
          <p>1918年の創業以来、時代の変化に合わせて次々と名品を発表してきたバレンシアガ。シンプルで気取らないデザインのバッグは、普段のコーデに合わせるだけで上級者のオシャレを演出できるとインスタグラムなどのSNSでも話題。バレンシアガのバッグであなたもオシャレ上級者に変身してみませんか？</p>
        </div>                                                
        <Link to="https://laxus.co/app/pc/bags/balenciaga" className="view-all-button">
          バレンシアガのバッグを見る
        </Link>                
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post29

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 29}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
